import { ANNOTATION_VALUE } from "@/constants/annotation-values"

import type { TargetCondition } from "@/types/metrics/contracts"
import type { RunMetricOutput } from "@/types/RunMetricOutput"

import { deriveYesNoString } from "./binaryValue"
import { resolveBinaryTargetCondition } from "./resolveThreshold"

export function calculateBinaryPassRate(
  mos: RunMetricOutput[],
  includeUnknowns: boolean,
  targetCondition?: TargetCondition,
): number | null {
  const condition = resolveBinaryTargetCondition({
    metric_metadata: { target_condition: targetCondition },
  })
  const values = mos
    .map(deriveYesNoString)
    .filter((value) => includeUnknowns || value !== ANNOTATION_VALUE.UNKNOWN)
  if (values.length === 0) {
    return null
  }
  const successCount = values.filter((value) => {
    if (value === ANNOTATION_VALUE.UNKNOWN) {
      return false
    }
    const inTarget = condition.target_values.includes(value)
    return condition.comparison_operator === "in" ? inTarget : !inTarget
  }).length
  return successCount / values.length
}

export function calculateBinaryHeaderPercent(
  mos: RunMetricOutput[],
  includeUnknowns: boolean,
  targetCondition?: TargetCondition,
): string | null {
  const rate = calculateBinaryPassRate(mos, includeUnknowns, targetCondition)
  return rate === null ? null : `${(rate * 100).toFixed(0)}%`
}

export function hasBinaryUnknowns(mos: RunMetricOutput[]): boolean {
  return mos.some((m) => deriveYesNoString(m) === ANNOTATION_VALUE.UNKNOWN)
}
